module.exports = __webpack_public_path__ + "static/media/3.33fd3d81.jpg";